import { Component, OnInit } from "@angular/core"

import { SessionService } from "src/app/services/session.service"
import { toastrService } from "src/app/services/ux/toastr.service"
import { UserHttpClientService } from "src/app/data/user-http-client.service";
import { UserWallet } from "src/app/models/User/user-wallet"
import { Client } from "src/app/services/API/client";
import { TransferHistory } from "src/app/models/transfer-history/transfer-history";
import { LocaleConverterService } from "src/app/common/helpers/locale-converter.service";
import { environment } from "src/environments/environment";
import { SetTitleService } from "src/app/services/set-title.service";
import { User } from "src/app/models/User/user";

@Component({
  templateUrl: "./transfer-history.component.html",
  styleUrls: ["./transfer-history.component.css"]
})

export class TransferHistoryComponent implements OnInit {
  environment: any
  loading: boolean = false
  wallets: UserWallet[] = []
  selectedWalletId: number = 0
  items: TransferHistory[] = []
  transferType: string = "0" // 0 - all, 1 - Inside bank, 2 - Outside bank
  pageNumber: number = 1
  pageSize: number = 10
  totalRecords: number = 0
  openingRecord: TransferHistory | null = null
  isAuthorized: boolean

  constructor(
    public toastr: toastrService,
    private session: SessionService,
    private userService: UserHttpClientService,
    private client: Client,
    private converter: LocaleConverterService,
    private settitleservice : SetTitleService
  ) {
    this.environment = environment
  }

  async ngOnInit() {
    await this.getWallets();
    this.settitleservice.sendTitle("My Transfers");
    this.userService.getUserDetails().subscribe((user: User) => {
      this.isAuthorized = user.is_authorized;
  });
  }

  async getWallets() {
    if (!this.session.isLoggedIn()) return
    
    this.loading = true

    this.userService.getUserWallets()
      .subscribe({
        next: (wallets: UserWallet[]) => {
          this.wallets = wallets
          if (wallets[0]) {
            this.selectedWalletId = wallets[0].walletId
          }
          this.loading = false
          this.getHistory()
        },
        error: (err) => {
          this.toastr.error(err)
          this.loading = false
        }
      });
  }

  setSelectedWalletId(walletId: number) {
    if (this.selectedWalletId === walletId) return
    this.selectedWalletId = walletId
    this.getHistory()
  }

  setTransferType(value: string) {
    if (this.transferType === value) return
    this.transferType = value
    this.getHistory()
  }

  getSelectedWallet() {
    return this.wallets.find(item => item.walletId === Number(this.selectedWalletId))
  }

  async getHistory() {
    const { currencyCode } =  this.getSelectedWallet()
    const { pageNumber, pageSize, transferType } = this

    this.loading = true

    try {
      const res: any = await this.client.get("api/transfers/banktransferhistory", { pageNumber, pageSize, transferType, currencyCode })
      this.totalRecords = res.totalRecords || 0
      this.items = res.data
    } catch(err) {
      this.toastr.error(err)
    }

    this.loading = false
  }

  isFirstPage() {
    return this.pageNumber === 1
  }

  isLastPage() {
    return this.pageNumber * this.pageSize >= this.totalRecords
  }

  onPrevious() {
    if (this.loading || this.isFirstPage()) return
    --this.pageNumber
    this.getHistory() 
  }

  onNext() {
    if(this.loading || this.isLastPage()) return
    ++this.pageNumber
    this.getHistory()
  }

  open(record: TransferHistory) {
    this.openingRecord = record
  }

  close() {
    this.openingRecord = null
  }
}